/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_Th1Inputs */

const en_mk_cmp_multica_th1 = /** @type {(inputs: Mk_Cmp_Multica_Th1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must connect a computer and install at least one coding CLI before agents will run.`)
};

const id_mk_cmp_multica_th1 = /** @type {(inputs: Mk_Cmp_Multica_Th1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harus menghubungkan komputer dan memasang minimal satu CLI koding sebelum agen mau jalan.`)
};

/**
* | output |
* | --- |
* | "You must connect a computer and install at least one coding CLI before agents will run." |
*
* @param {Mk_Cmp_Multica_Th1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_th1 = /** @type {((inputs?: Mk_Cmp_Multica_Th1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_Th1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_th1(inputs)
	return en_mk_cmp_multica_th1(inputs)
});